import React, { useState, useEffect, useMemo, useRef, lazy, Suspense } from "react";
import { Modal, Button, Form, Row, Col, } from "react-bootstrap";
import moment from "moment";
import 'react-datepicker/dist/react-datepicker.css';
import ModalSelectResources from "../ModalSelectResources";
import { useSelector } from "react-redux";
import {
  calcularDuracion,
  getFileNamesInput,
  getFilesSize,
  getData,
  inputChange,
  saveDataScrum,
  updateDataScrum,
  deleteDataScrum,
  calcularDuracionMinutes
} from "../../../helpers";
import { selectTooltip ,selectTooltip_en } from "../../../utils/selectTooltip";
import ReactTooltip from "react-tooltip";
import SelectInModal from "../SelectInModal";
import { downloadAttachment, deleteAttachments, getAttachments, uploadAttachments } from "../../../services/tasks.services";
import swal from "sweetalert";
import useTaskFiles from "./hooks/useTaskFiles";
import { getTaskFilesAdapter } from "../../../adapters/tasks.adapters";
import ModalSelectTags from "../ModalSelectTags";
import { useTranslation } from "react-i18next";

import ReactDatePicker from 'react-datepicker';
import { registerLocale } from 'react-datepicker';
import { es } from 'date-fns/locale';
import 'react-datepicker/dist/react-datepicker.css';
import { getHours, getMinutes, setHours, setMinutes } from 'date-fns'
import Swal from "sweetalert2";
registerLocale('es',es)

const ModalAvancedOptions = lazy(()=> import('../ModalAvancedOptions'))

const ModalEditTask = (props) => {
  const ID_ORGANIZACION = process.env.REACT_APP_MODAL_EDIT_TASK_ID_ORG;
  const [t,i18n] =useTranslation("planning")
  const prevLaneId = useMemo(() => props.data.current.laneId);
  const [taskData, setTaskData] = useState({});
  const [showResources, setShowResources] = useState(false);
  const [showTags, setShowTags] = useState(false);
  const [showSelectHus, setShowSelectHus] = useState(false);
  const [selectedResources, setSelectedResources] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const [filesName, setFilesName] = useState("");
  const [uploadingFiles, setUploadingFiles] = useState(false);
  const [files, dispatchFiles] = useTaskFiles();
  const [excludeDates, setExcludeDates] = useState([]);
  const [showTrack, setShowTrack]= useState(false)
  
  const [getTrack, setGetTrack] = useState("")
  const [showNotes, setShowNotes]= useState(false)
  const [notesData, setNotesData]= useState([])
  const [ newNote, setNewNote]=useState("")
  const [editNotes, setEditNotes] = useState(false)
  const [enableEdit, setEnableEdit]=useState()
  const [customFields,setCustomFields]= useState([])
  const [showAvancedOptions, setShowAvancedOptions] = useState(false);
  const scrum = useSelector((state) => state.scrum);
  const userStories = scrum.ddlStories.map((story, index) => {
    return {
      value: story.id,
      label: story.TituloHistoriaUsuario
    };
  });

  const handleShowAcvancedOptions =(e) =>{
    setShowAvancedOptions((val)=> val =! val)
  
  }

  const _getValue = (selector) => {
    if (
      typeof taskData.metadata != "undefined" &&
      typeof taskData.metadata[selector] != "undefined"
    ) {
      let val = taskData.metadata[selector];

      return val;
    } else {
      return null;
    }
  };

  const toPlainText = (rawValue) => {
    return String(rawValue ?? "")
      .replace(/<br\s*\/?>/gi, "\n")
      .replace(/<[^>]*>/g, "");
  };
 

  const getValueKm = (data) =>{
    const valoresSeguimiento = [Number(data?.custom_Seguimiento1),Number(data?.custom_Seguimiento2),Number(data?.custom_Seguimiento3),Number(data?.custom_Seguimiento4),Number(data?.custom_Seguimiento5)]
    const initialValue = 0
    const TotalkmS = valoresSeguimiento?.reduce(
      (acum,current) => acum + current,
      initialValue)
    
    return TotalkmS.toFixed(2)
  }

  const getValueKmDesvi = (data) =>{

    const valoresSeguimiento = [Number(data?.custom_Seguimiento1),Number(data?.custom_Seguimiento2),Number(data?.custom_Seguimiento3),Number(data?.custom_Seguimiento4),Number(data?.custom_Seguimiento5)]
    const initialValue = 0
    const TotalkmS = valoresSeguimiento?.reduce(
      (acum,current) => acum + current,
      initialValue)
    
    return (TotalkmS.toFixed(2) - Number(data?.custom_KmPlaneados ).toFixed(2)).toFixed(2)

  }
  const dateChanged = (e) => {
    let dates = {
      startDate:
        e.target.name === "startDate"
          ? e.target.value
          : moment(taskData.metadata.startDate)._d,
      endDate:
        e.target.name === "endDate"
          ? e.target.value
          : moment(taskData.metadata.endDate)._d
    };
    if(!props.hasDurationHours){
      let duration = calcularDuracion(dates.startDate, dates.endDate);
      setTaskData((prev) => {
        return {
          ...prev,
          metadata: {
            ...prev.metadata,
            [e.target.name]: e.target.value,
            duration: duration,
            HorasEjecutadas: duration * 8
          }
        };
      });

    }else{
      let durationInMinutes= calcularDuracionMinutes(dates.startDate, dates.endDate)
      setTaskData((prev) => {
        return {
          ...prev,
          metadata: {
            ...prev.metadata,
            [e.target.name]: e.target.value,
            duration: durationInMinutes,
          }
        };
      });
    }
  };

  const _changeInput = (e) => {
    const __returnZeroIfNumber = (type, value) => {
      if (type === "number" && value === "") {
        return 0;
      } else {
        return value;
      }
    };
    if (e.target.name === "title") {
      setTaskData((prev) => {
        return {
          ...prev,
          [e.target.name]: e.target.value
        };
      });
    } else {
      setTaskData((prev) => {
        return {
          ...prev,
          metadata: {
            ...prev.metadata,
            [e.target.name]: __returnZeroIfNumber(e.target.type, e.target.value)
          }
        };
      });
    }
  };
  const _changeSprint = (e) => {
    setTaskData((prev) => {
      return {
        ...prev,
        [e.target.name]: e.target.value
      };
    });
  };

  const _saveTask = (data) => {

    const arrayOne = Object.entries(data.metadata)
    const arrayTwo = arrayOne.filter((aone)=> {
      return aone[0].includes("custom_")
    })

    const arraythree = arrayTwo.map((atwo)=>{
      return {
        name : atwo[0],
        value : atwo[1]
      }
    })
    const formCustomField = 
    [
      {
        name : "custom_KmPlaneados",
        value : data.metadata?.custom_KmPlaneados
      },
      {
        name : "custom_Seguimiento1",
        value : data.metadata?.custom_Seguimiento1
      },
      {
        name : "custom_Seguimiento2",
        value : data.metadata?.custom_Seguimiento2
        
      },
      {
        name : "custom_Seguimiento3",
        value : data.metadata?.custom_Seguimiento3
      },
      {
        name : "custom_Seguimiento4",
        value : data.metadata?.custom_Seguimiento4
        
      },
      {
        name : "custom_Seguimiento5",
        value : data.metadata?.custom_Seguimiento5
        
      }

    ]
    const customfieldUpdateInfo = props.customFields?.map((field)=>{
      return {
        IdActividad : data.id,
        IdCampoPersonalizado : field.IdCampoPersonalizado,
        fieldValue : formCustomField.filter((cust)=>{
            return cust.name == field.name
        })[0].value
      }
    })

    data.customFieldValues = customfieldUpdateInfo
    let dummie = data;
    dummie.metadata.resources = selectedResources;
    dummie.metadata.tags = selectedTags;
    let adjuntos = [];
    for (let i = 0; i < filesInput.current.files.length; i++) {
      const file = filesInput.current.files.item([i]);
      adjuntos.push(file);
    }
    dummie.adjuntos = adjuntos;
    if (data.laneId !== prevLaneId) {
      dummie = {
        ...dummie,
        prevLaneId: prevLaneId
      };
    }
    props.update(dummie);
    props.setShow(false);
  };

  const handleUploadFiles = () => {
    setUploadingFiles(true);
    let attachments = [];
    for (let i = 0; i < filesInput.current.files.length; i++) {
      const file = filesInput.current.files.item([i]);
      attachments.push(file);
    }
    let payload = {
      id: taskData.id,
      projectId: taskData.metadata.ProyectoId,
      files: attachments
    };
    uploadAttachments(payload)
      .then((res) => {
        setUploadingFiles(false);
        setFilesName("");
        swal(t("modal_creationactivities_done"), t("modal_creationactivities_upload"), "success").then(() =>
          getAttachedFiles(props.data.current.id)
        );
      })
      .catch((err) => {
        alert(`Ups, ${t("modal_creationactivities_erroupload")}`);
        console.log(err);
        setUploadingFiles(false);
      });
  };

  const formTask = useRef();
  const filesInput = useRef();
  const noteref = useRef();

  const handleInputFileChange = (e) => {
    if (getFilesSize(e.target.files) > 20971520) {
      alert(
        t("modal_creationactivities_maxload")
      );
      e.target.value = "";
      setFilesName("");
      return;
    }
    setFilesName(getFileNamesInput(e.target.files));
  };

  const getAttachedFiles = (taskId) => {
    dispatchFiles({
      type: "LOADING"
    });
    getAttachments(taskId).then((res) => {
      dispatchFiles({
        type: "SET_FILES",
        payload: getTaskFilesAdapter(res.data) 
      });
    });
  };

  const downloadFile = (filePath) => {
    downloadAttachment(filePath).then((res) => {
      var file = window.URL.createObjectURL(res.data);
      window.open(file);
    });
  };

  const deleteFile =(fileId, fileurl) => {
    swal({
      title: t("modal_creationactivities_deletefile"),
      text: t("modal_creationactivities_deletefile_2"),
      icon: "warning",
      buttons: true,
      buttons: [t("modal_creationactivities_deletefile_3"), t("modal_creationactivities_deletefile_4")],
      dangerMode: true 
    }).then((willDelete) => {
      if (willDelete) {
        let dataForDelete = {
          filId:fileId,
          filurl : fileurl 
        }
        deleteAttachments(dataForDelete)
        .then((res)=> {
          swal(t("modal_creationactivities_done"), t("modal_creationactivities_deletefile_5"), "success").then(() =>
          window.location.reload()
        );
        }
        )
      }
    });
  }

  useEffect(() => {
    if (!props.show) {
      dispatchFiles({ type: "RESET" });
      setFilesName("");
      return;
    }
    if (props.data.current.metadata) {
      setTaskData(props.data.current);
      setSelectedResources(props.data.current.metadata.resources || []);
      setSelectedTags(props.data.current.metadata?.tags|| [])
      setCustomFields(props.data.current.metadata?.customField)
      getAttachedFiles(props.data.current.id);
      getAllNotes(props.data.current.id)

      if(props.data.current.metadata?.ProyectoId){ 
        getTaskTracking(props.data.current.metadata?.ProyectoId, props.data.current.id)
      }
    }
  }, [props.show]);

  useEffect(() => {
    ReactTooltip.rebuild();
  });

  const getExcludedDates = () => {
    Promise.all([
      getData(`excluded-dates/agile`, {})
    ]).then((values) => {
      setExcludeDates(values[0])
    });
  };

  const getTaskTracking = (projectId, taskId) => {
   Promise.all([
    getData(`agile-task-tracking/${projectId}/${taskId}`,{}),
   ]).then((values)=>{
    setGetTrack(values[0])
   })
  }

  const getAllNotes = (taskId) => {
    Promise.all([
     getData(`agile-task-notes/${taskId}`,{}),
    ]).then((values)=>{
      setNotesData(values[0])
    })
   }

  useEffect(() => {
    const controller = new AbortController()
    getExcludedDates()
    return () =>{
      controller.abort()
    }
  }, []);
  const sizeModal = (props.titleColumn.current ==="Product Backlog") ? "md":"xl"
  const allExcludeDates = excludeDates.map((date) => new Date(date));

  const addFiles = t("modal_creationactivities_textbox1")
  
  const handleOnChangeForNotes = (e,id) => {

   if(e.target.name == "text")
    setNotesData((prev)=> {
      prev.map((itprev)=>{
        if(itprev.idComment == id){
          itprev.text = e.target.value
        }
        return itprev
      })
      return [...prev]
    })
    
  }
 
  const handleEditNote = (id) =>{
    setEnableEdit(id)
  }
  const createNewNote = (e) => {
    let newNoteData = {
      taskId: props.data.current.id,
      noteText: newNote.newComment,
    };
    saveDataScrum("agile-task-notes", newNoteData)
      .then((res) => {
        getAllNotes(newNoteData.taskId)
        noteref.current.value = ""
      })
      .catch((error) => {
        swal("¡Ups!", "Hubo un error al crear la nota", "error");
    });
  };

  const editNote = (id)=>{
    let noteToEdit  = notesData.filter((it)=> it.idComment == id)
    const noteEdit ={
      id : noteToEdit[0].idComment,
      text : noteToEdit[0].text,
      idProject : noteToEdit[0].idProject
    }
    updateDataScrum(`agile-task-notes/${noteEdit.id}`, noteEdit)
        .then((res) => {
          getAllNotes( props.data.current.id)
          setEnableEdit()
        })
        .catch((err) =>
          swal(
            "¡Ups!",
            "Hubo un error al actualizar los datos la nota, por favor refresca la página.",
            "error"
          )
      );
  }

  const deleteNote = (id)=>{
    swal({
      title: t("modal_creationactivities_deletenote"),
      text: t("modal_creationactivities_deletenote_2"),
      icon: "warning",
      buttons: true,
      buttons: [t("modal_creationactivities_deletefile_3"), t("modal_creationactivities_deletefile_4")],
      dangerMode: true 
    }).then((willDelete) => {
      if (willDelete) {
        let noteToEdit  = notesData.filter((it)=> it.idComment == id)
        deleteDataScrum(`agile-task-notes-delete/${noteToEdit[0].idComment}`)
        .then((res)=> {
          swal(t("modal_creationactivities_done"), t("modal_creationactivities_deletenote_5"), "success").catch((err) =>
          swal(
            "¡Ups!",
            "Hubo un error al eliminar la actividad, por favor refresca la página.",
            "error"
          ))
          getAllNotes( props.data.current.id)
        }
        )
      }
    });
  }

  const commentsToShow = () => { 
    if(notesData.length > 3 && showNotes == false ){
      let notesSlice= notesData.slice(0,3)
      return notesSlice
    }else
    return notesData
  }

  const numberOfnotes = ()=> {
    if(notesData){
      return notesData.length
    }
  } 

  const idProfileRol = (window.localStorage.getItem("cm9sX3VzdWFyaW8=") == 108 )? true : false

  const idOrganization = localStorage.getItem('OID')
  

  const handleValidations = (e, taskdata) => {
    e.preventDefault()
    if(taskdata.metadata.startDate && taskdata.metadata.endDate){
      _saveTask(taskdata);
      setTaskData({});

    }else {
      Swal.fire("Error","Por favor ingrese Fecha de inicio y Fecha Finalización de la actividad","error")
    }

  };
  const getMinTimeWork = ()=>{
   let startComp = _getValue("startDate") && moment(_getValue("startDate")).add(props.hasDurationHours ? 0 : 5, "hours")._d
   let endComp = _getValue("endDate") && moment(_getValue("endDate")).add(props.hasDurationHours ? 0 : 5, "hours")._d
   if( startComp?.toDateString() ===  endComp?.toDateString()){
    let hours = getHours(startComp)
    let minutes = getMinutes(startComp)
    return setHours(setMinutes(new Date(),minutes),hours)
   }else{
    return setHours(setMinutes(new Date(),30),7)
   }
  }

  return (
    <>
      <Modal

        show={props.show}
        onHide={() => {
          props.setShow(false);
          setTaskData({});
        }}
        size={sizeModal}
        contentClassName="border-0 shadow-lg"
      >
        <Form 
          ref={formTask}
          id="form-comple"
          className={(idProfileRol)? "disable-product-backlog" : ""}
          >
          <div
            className="progress rounded"
            title={`${taskData.metadata?.progress}% Completado`}
            style={{
              height: "8px",
              borderRadius: 0
            }}
          >
            <div
              className={`progress-bar ${
                taskData.metadata?.progress < 100 ? "bg-info" : "bg-success"
              }`}
              role="progressbar"
              style={{ width: `${taskData.metadata?.progress}%` }}
            ></div>
          </div>
          <Modal.Header>
            <Modal.Title className="h5 w-100">
              <input
                type="text"
                placeholder="Nombre del item"
                name="title"
                disabled={(props.rol == "Miembro de Equipo" || props.rol == "Ejecutivo")? true:false}
                value={taskData.title || ""}
                className="border-0"
                style={{ width: "100%" }}
                onChange={(e) => {
                  _changeInput(e);
                }}
              />
            </Modal.Title>
              <Button onClick={(e) => {
                props.setShow(false);
              }} variant="light">X</Button>
          </Modal.Header >
          <Modal.Body>
              <div className="d-flex justify-content-end">
                <h6 className="mr-2">Opciones avanzadas</h6>
                <button
                  type="button"
                  className="btn btn-sm btn-outline-info"
                  onClick={(e)=>handleShowAcvancedOptions(e)}
                >
                  <i className="fa fa-cog"></i>
                </button>
              </div>
           {/*    <hr/> */}
           <div className="p-3 mb-3 bg-light rounded shadow-sm section-block mt-1">
                <h6 className="text-primary mb-3">
                  <i className="fa fa-users-cog mr-2"></i>
                  Equipo
                </h6>
            <div
              className="mb-3 d-inline-block"
              onClick={() =>{
                if(props.rol == "Miembro de Equipo" || props.rol == "Ejecutivo"){
                  return
                }else{
                  setShowResources(true)
                }
              }}
              style={{ cursor: "pointer" }}
            >
              <i className="fa fa-user-plus text-muted mr-2"></i>
              {selectedResources.length > 0 ? (
                selectedResources.map((item) => {
                  return (
                    <span
                      key={item.id}
                      className="badge bg-info text-white mr-1"
                    >
                      {item.name}
                    </span>
                  );
                })
              ) : (
                <span className="text-primary">{t("modal_creationactivities_text1")}</span>
              )}
            </div>
            </div>
            {!props.hideTags &&
            <>
               <div className="p-3 mb-3 bg-light rounded shadow-sm section-block">
                <h6 className="text-primary mb-3">
                  <i className="fa fa-tags mr-2"></i>
                  Etiquetas
                </h6>
            <div
              className="mb-3 d-inline-block"
              onClick={() =>{
                if(props.rol == "Miembro de Equipo" || props.rol == "Ejecutivo"){
                  return
                }else{
                  setShowTags(true)
                }
                }}
              style={{ cursor: "pointer" }}
            >
              <i className="fa fa-tag text-muted mr-2"></i>
              {selectedTags.length > 0 ? (
                selectedTags.map((item) => {
                  
                  return (
                    <span
                      style = {{backgroundColor: item.Color}}
                      key={item.Id}
                      className="badge text-white mr-1"
                    >
                      {item.NombreEtiqueta}
                    </span>
                  );
                })
              ) : (
                <span className="text-primary">{t("modal_creationactivities_text2")}</span>
              )}
            </div>
            </div>
            </>
            }
                <div className="p-3 mb-3 bg-light rounded shadow-sm section-block">
                    <h6 className="text-primary mb-3">
                      <i className="fa fa-calendar-alt mr-2"></i>
                      {t("modal_creationactivities_text3")}
                    </h6>
                <Row>
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>{t("modal_creationactivities_text4")}</Form.Label>
                      <br />
                      <ReactDatePicker
                        selected={
                          _getValue("startDate") &&
                          moment(_getValue("startDate")).add(props.hasDurationHours ? 0 : 5, "hours")._d
                        }
                        showTimeSelect = {props.hasDurationHours? true : false}
                        dateFormat = {props.hasDurationHours ? "dd-MM-yyyy h:mm aa":"dd/MM/yyyy"}
                        timeFormat="h:mm aa"
                        timeCaption="Hora"
                        minTime={ setHours(setMinutes(new Date(),30),7)}
                        maxTime={ setHours(setMinutes(new Date(),0),17)}
                        locale = "es"
                        excludeDates={allExcludeDates}
                        filterDate ={date => date.getDay() !== 6 && date.getDay() !== 0}
                        wrapperClassName="w-100"
                        className="form-control"
                        onChange={(date) => {
                          let e = { target: {} };
                          e.target.name = "startDate";
                          e.target.value = date;
                          dateChanged(e);
                        }}
                        disabled={(props.rol == "Miembro de Equipo" || props.rol == "Ejecutivo")? true:false}
                        isClearable = {(props.rol == "Miembro de Equipo" || props.rol == "Ejecutivo")? false : true}
                        closeOnScroll={true}
                        required
                        form="external-form"
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>{t("modal_creationactivities_text5")}</Form.Label>
                      <br />
                      <ReactDatePicker
                        selected={
                          _getValue("endDate") &&
                          moment(_getValue("endDate")).add(props.hasDurationHours ? 0 : 5, "hours")._d
                        }
                        showTimeSelect = {props.hasDurationHours? true : false}
                        locale = "es"
                        dateFormat = {props.hasDurationHours ? "dd-MM-yyyy h:mm aa":"dd/MM/yyyy"}
                        timeFormat="h:mm aa"
                        timeCaption="Hora"
                        minTime={ getMinTimeWork()}
                        maxTime={ setHours(setMinutes(new Date(),0),17)}
                        excludeDates={allExcludeDates}
                        disabled={_getValue("startDate") ? false : true}
                        filterDate ={date => date.getDay() !== 6 && date.getDay() !== 0}
                        minDate={ _getValue("startDate") &&
                        moment(_getValue("startDate")).add( props.hasDurationHours ? 0 : 5, "hours")._d}  
                        wrapperClassName="w-100"
                        className="form-control" 
                        onChange={(date) => {
                          let e = { target: {} };
                          e.target.name = "endDate";
                          e.target.value = date;
                          dateChanged(e);
                        }}
                        readOnly={(props.rol == "Miembro de Equipo" || props.rol == "Ejecutivo")? true : false}
                        isClearable = {(props.rol == "Miembro de Equipo" || props.rol == "Ejecutivo")? false : true}
                        closeOnScroll={true}
                        required
                        form="external-form"
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>
                        {t("modal_creationactivities_text6")} <small>{t("modal_creationactivities_text7")}</small>
                      </Form.Label>
                      <br />
                      <ReactDatePicker
                        wrapperClassName="w-100"
                        selected={
                          _getValue("expirationDate") &&
                          moment(_getValue("expirationDate")).add( props.hasDurationHours ? 0 : 5, "hours")._d
                        }
                        dateFormat = {props.hasDurationHours ? "dd-MM-yyyy h:mm aa":"dd/MM/yyyy"}
                        timeFormat="h:mm aa"
                        timeCaption="Hora"
                        showTimeSelect = {props.hasDurationHours? true : false}
                        locale = "es"
                        className="form-control"
                        excludeDates={allExcludeDates}
                        filterDate ={date => date.getDay() !== 6 && date.getDay() !== 0}
                        disabled={_getValue("startDate") ? false : true}
                        minDate={ _getValue("endDate") &&
                        moment(_getValue("endDate")).add(props.hasDurationHours ? 0 : 5, "hours")._d}  
                        onChange={(date) => {
                          let e = { target: {} };
                          e.target.name = "expirationDate";
                          e.target.value = date;
                          _changeInput(e);
                        }}
                        readOnly={(props.rol == "Miembro de Equipo" || props.rol == "Ejecutivo" || props.conditionManagerAdvisory)? true : false}
                        isClearable = {(props.rol == "Miembro de Equipo" || props.rol == "Ejecutivo" )? false : true}
                        closeOnScroll={true}
                        form="external-form"
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={3}>
                    <Form.Group>
                      <Form.Label>
                        {t("modal_creationactivities_text8")} <small>{props.hasDurationHours? t("modal_creationactivities_text9.1") : t("modal_creationactivities_text9")} </small>
                      </Form.Label>
                      <Form.Control
                        type="number"
                        min={0.1}
                        placeholder="0"
                        name="duration"
                        value={taskData.metadata?.duration}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group>
                      <Form.Label
                        data-tip={(t("planningboard_lenguaje") == "es")? selectTooltip(34): selectTooltip_en(34)}
                        data-class="pwc-tooltip shadow-lg py-3 tip-to-front"
                      >
                        Esfuerzo Planeado <small>(Horas hábiles)</small>
                      </Form.Label>
                      <Form.Control
                        type="number"
                        placeholder="0"
                        step={0.1}
                        min="1"
                        name="HorasPlaneadas"
                        value={_getValue("HorasPlaneadas")}
                        onFocus={(e) => {
                          e.target.select();
                        }}
                        onChange={(e) => {
                          _changeInput(e);
                        }}
                        disabled={(props.rol == "Miembro de Equipo" || props.rol == "Ejecutivo")? true:false}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group>
                      <Form.Label
                        data-tip={(t("planningboard_lenguaje") == "es")? selectTooltip(34): selectTooltip_en(34)}
                        data-class="pwc-tooltip shadow-lg py-3 tip-to-front"
                      >

                        Esfuerzo Real <small>(Horas hábiles)</small>
                      </Form.Label>
                      <Form.Control
                        type="number"
                        placeholder="0"
                        step={0.1}
                        min="1"
                        name="HorasEjecutadas"
                        value={_getValue("HorasEjecutadas")}
                        onFocus={(e) => {
                          e.target.select();
                        }}
                        onChange={(e) => {
                          _changeInput(e);
                        }}
                        disabled={(props.rol == "Miembro de Equipo" || props.rol == "Ejecutivo")? true:false}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group>
                      <Form.Label
                        className={
                          _getValue("progress") < 100
                            ? "text-info"
                            : "text-success"
                        }
                      >
                        {t("modal_creationactivities_text10")} 
                      </Form.Label>
                      <Form.Control
                        as="select"
                        className="border-info"
                        name="progress"
                        value={_getValue("progress")}
                        onClick={(e) => {
                          return e.target.value;
                        }}
                        onChange={(e) => {
                          if (e.target.value > 100) {
                            e.target.value = 100;
                          }
                          _changeInput(e);
                        }}
                        disabled={( props.rol == "Ejecutivo")? true : false}
                      >
                        <option key="0" value="0">
                          To Do
                        </option>
                        <option key="50" value="50">
                          Doing
                        </option>
                        <option key="100" value="100">
                          Done
                        </option>
                      </Form.Control>
                    </Form.Group>
                  </Col>
                </Row>
                </div>
              {/* SECCIÓN 2: EQUIPO Y METODOLOGÍA */}
              <div className="p-3 mb-3 bg-light rounded shadow-sm section-block">
                <h6 className="text-primary mb-3">
                  <i className="fa fa-clipboard-list mr-2"></i>
                  Historias de Usuario y Sprint
                </h6>
                <Row>
                  {!props.hideStories && (
                    <Col md={4}>
                      <Form.Group>
                        <Form.Label>{t("modal_creationactivities_text11")}</Form.Label>
                        <Form.Control
                          as="select"
                          name="HistoriaUsuarioId"
                          value={_getValue("HistoriaUsuarioId")}
                          onClick={(e) => {
                            setShowSelectHus(true);
                          }}
                          onChange={(e) => {
                            _changeInput(e);
                          }}
                          disabled={(props.rol == "Miembro de Equipo" || props.rol == "Ejecutivo")? true:false}
                        >
                          <option value="">{t("modal_editsprint_text2_1")}...</option>
                          {userStories !== undefined &&
                            userStories.map((item, index) => {
                              return (
                                <option key={item.value} value={item.value}>
                                  {item.label}
                                </option>
                              );
                            })}
                        </Form.Control>
                        <SelectInModal
                          title={t("modal_creationactivities_text11_1")}
                          noneLabel={t("modal_creationactivities_text11_6")}
                          show={showSelectHus}
                          value={_getValue("HistoriaUsuarioId")}
                          onClose={() => {
                            setShowSelectHus(false);
                          }}
                          items={userStories} // all hus
                          name="HistoriaUsuarioId"
                          onChange={(e) => _changeInput(e)}
                        />
                      </Form.Group>
                    </Col>
                  )}
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label
                      data-tip={(t("planningboard_lenguaje") == "es")? selectTooltip(40): selectTooltip_en(40)}
                      data-class="pwc-tooltip shadow-lg py-3 tip-to-front"
                      >
                        {t("modal_creationactivities_text13")} <small>(1 - 100)</small>
                      </Form.Label>
                      <Form.Control
                        type="number"
                        placeholder="0"
                        min="1"
                        max="100"
                        maxLength={3}
                        name="poValue"
                        value={_getValue("poValue") || 0}
                        onFocus={(e) => {
                          e.target.select();
                        }}
                        onChange={(e) => {
                         if(e.target.value > 100){
                          return 
                         }else{
                          _changeInput(e);
                         }
                        }}
                        disabled={(props.rol == "Miembro de Equipo" || props.rol == "Ejecutivo")? true:false}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Sprint</Form.Label>
                      <Form.Control
                        as="select"
                        name="laneId"
                        value={taskData.laneId}
                        onChange={(e) => {
                          _changeSprint(e);
                        }}
                        disabled
                      >
                        {props.sprints.map((item, index) => {
                          return index === 0 ? (
                            <option key={item.id} value={item.id}>
                              {item.title}
                            </option>
                          ) : (
                            <option key={item.id} value={item.id}>
                             {item.title}
                            </option>
                          );
                        })}
                      </Form.Control>
                    </Form.Group>
                  </Col>
                </Row>
              </div>
              {/* SECCIÓN 3: COSTOS (opcional) */}
                {props.enableCost && 
                <div className="p-3 mb-3 bg-light rounded shadow-sm section-block">
                <h6 className="text-primary mb-3">
                  <i className="fa fa-coins mr-2"></i>
                  {t("modal_creationactivities_text3_1")}
                </h6>            
                <Row>
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label
                      data-class="pwc-tooltip shadow-lg py-3 tip-to-front"
                      >
                        {t("planningboard_tooltip_card_11")}
                      </Form.Label>
                      <Form.Control
                        type="number"
                        placeholder="0"
                        min="0"
                        max="99999999999"
                        step="1000"
                        value={_getValue("CostoPlaneado") || 0}
                        name="CostoPlaneado"
                       
                        onFocus={(e) => {
                          e.target.select();
                        }}
                        onChange={(e) => {
                          
                          _changeInput(e);
                        }}
                        disabled={(props.rol == "Miembro de Equipo" || props.rol == "Ejecutivo")? true:false}
                      />        
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label
                      data-class="pwc-tooltip shadow-lg py-3 tip-to-front"
                      >
                        {t("planningboard_tooltip_card_12")}
                      </Form.Label>
                      <Form.Control
                        type="number"
                        placeholder="0"
                        min="0"
                        max="99999999999"
                        step={1000}
                        name="CostoReal"
                        value={_getValue("CostoReal") || 0}
                        onFocus={(e) => {
                          e.target.select();
                        }}
                        onChange={(e) => {
                          
                          _changeInput(e);
                        }}
                        disabled={(props.rol == "Miembro de Equipo" || props.rol == "Ejecutivo")? true:false}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                </div>
                }
                <>
                {(idOrganization == ID_ORGANIZACION ) && 
                <> 
                <hr/>
                <h6>Campos Personalizados</h6>
                <div className="d-flex flex-wrap w-80">
                  { props.customFields?.map((field,idx)=>{
                    return <Col key={idx} md={(idx == 0)? 8 : field.size} className="mx-2 p-0">
                            <Form.Group>
                              <Form.Label
                              data-class="pwc-tooltip shadow-lg py-3 tip-to-front"
                              >
                                {field.title}
                              </Form.Label>
                              <Form.Control
                              type={field.Type}
                              placeholder={field.ItemPlaceHolder}
                              min={field.minValue}
                              max={field.maxValue}
                              step={(field.step == 2)? "0.01": "1"}
                              name={field.name}
                              value= {_getValue(field.name) || 0}
                              readOnly={field?.readonly || false}
                              onFocus={(e)=>{
                                e.target.select()
                              }}
                              onChange={(e)=>{
                                _changeInput(e)
                              }}
                              disabled={(props.rol == "Miembro de Equipo" || props.rol == "Ejecutivo")? true:false}  
                              >
                              </Form.Control>
                            </Form.Group>
                          </Col>
                  })

                  }
                  <Col md={8} className="mx-2 p-0">
                    <Form.Group>
                      <Form.Label
                      data-class="pwc-tooltip shadow-lg py-3 tip-to-front"
                      >
                        Km Ejecutados
                      </Form.Label>
                      <Form.Control
                      type="number"
                      placeholder="0"
                      step={1}
                      name="kmejecutados"
                      value= {getValueKm( taskData.metadata) || 0}
                      readOnly={true}
                      onFocus={(e)=>{
                        e.target.select()
                      }}
                      disabled={(props.rol == "Miembro de Equipo" || props.rol == "Ejecutivo")? true:false}  
                      >
                      </Form.Control>
                    </Form.Group>
                  </Col>
                  <Col md={3} className="mx-2 p-0">
                    <Form.Group>
                      <Form.Label
                      data-class="pwc-tooltip shadow-lg py-3 tip-to-front"
                      >
                        Desviación
                      </Form.Label>
                      <Form.Control
                      type="number"
                      placeholder="0"
                      className= { 
                        (getValueKmDesvi( taskData.metadata) < 0 ) ? " font-weight-bold text-secondary border-danger" : " font-weight-bold text-success border-success"
                      }
                      step={1}
                      name="kmdesviacion"
                      value= {getValueKmDesvi( taskData.metadata)  || 0} 
                      readOnly={true}
                      onFocus={(e)=>{
                        e.target.select()
                      }}
                      disabled={(props.rol == "Miembro de Equipo" || props.rol == "Ejecutivo")? true:false}  
                      >
                      </Form.Control>
                    </Form.Group>
                  </Col>
                 </div>
                </> 
                }
                
                </>
              {/* SECCIÓN 4: ARCHIVOS ADJUNTOS */}
              <div className="p-3 mb-3 bg-light rounded shadow-sm section-block">
                <h6 className="text-primary mb-3">
                  <i className="fa fa-paperclip mr-2"></i>
                  Archivos adjuntos
                </h6>
                <Row>
                  <Col lg={6}>
                    <Form.Label>{t("modal_creationactivities_text14")}</Form.Label>
                    <div className="d-flex">
                      <Form.Control
                        type="file"
                        ref={filesInput}
                        id="add-task-file"
                        label={filesName || addFiles}
                        data-browse={t("modal_creationactivities_button_search")}
                        accept="image/png, image/jpeg, .pdf, .doc, .docx, .xls"
                        custom
                        multiple
                        onChange={handleInputFileChange}
                        disabled={( props.rol == "Ejecutivo")? true : false}
                      />
                      {filesName && (
                        <Button
                          title={
                            uploadingFiles
                              ? t("modal_creationactivities_button_upload")
                              : t("modal_creationactivities_button_upload_1")
                          }
                          onClick={handleUploadFiles}
                          variant="info"
                          className="ml-3 animate__animated animate__fadeIn animate__repeat-1"
                          disabled={uploadingFiles ? true : false}
                        >
                          {uploadingFiles ? (
                            <i className="fa fa-spinner animate__animated animate__rotateOut animate__infinite"></i>
                          ) : (
                            <i className="fa fa-upload"></i>
                          )}
                        </Button>
                      )}
                    </div>
                    <small className="text-danger">
                      {t("modal_creationactivities_text17")}
                    </small>
                    <br/>
                    <small className="text-danger">
                      {t("modal_creationactivities_text18")}
                    </small>
                  </Col>
                  <Col lg={6}>
                    <Form.Label>{t("modal_creationactivities_text15")} ( {files?.files?.length} )</Form.Label>
                    <br />
                    <div style={{ maxHeight: "75px", overflow: "auto" }}>
                      {files?.loading ? (
                        <i className="fa fa-spinner animate__animated animate__rotateOut animate__infinite"></i>
                      ) : files?.error ? (
                        <small className="text-danger">
                          {t("modal_creationactivities_text15_1")}
                        </small>
                      ) : files?.files?.length ?
                        <small className ="table-responsive">
                        <table className="table table-striped">
                          <tbody>
                            {files.files.map((file,idx) => {
                              return <tr key={idx}>
                                  <th><a href="#" onClick={() => {downloadFile(file.url);}}>{file.fileName}</a></th>
                                  <th>
                                  <i
                                    style={{cursor:"pointer"}}
                                    onClick={()=> deleteFile(file.fileId, file.url)}
                                    className="fa fa-trash-alt ml-2 text-danger">
                                  </i>
                                  </th> 
                              </tr>
                            })}
                          </tbody>
                        </table>
                        </small>
                       : (
                        <small className="text-muted">
                          {t("modal_creationactivities_text16")}
                        </small>
                      )}
                    </div>
                    <br />
                  </Col>
                </Row>
              </div>
              {/* SECCIÓN 5: REGISTRAR AVANCE O NOTA */}
              <div className="p-3 bg-light rounded shadow-sm section-block">
                <h6 className="text-primary mb-3">
                  <i className="fa fa-sticky-note mr-2"></i>
                  Registrar avance o nota
                </h6>
                <Row>
                <Col lg={12}>
                {(notesData?.length > 3) &&
                  <Button
                    variant="outline-info"
                    size ="sm"
                    className="mt-0 mb-2"
                    onClick={()=> {
                      setShowNotes(value => value = !value)
                    }}
                    >
                        {(!showNotes)? <>
                          {t("modal_creationactivities_notes_4")}
                        ( {numberOfnotes()} )
                          </>
                          : <>{t("modal_creationactivities_notes_5")}( 3 )</>
                        }
                  </Button>
                }
                <Row className="px-1 mb-0" style={{backgroundColor:"#e9ecef",borderTopLeftRadius:"5px",borderTopRightRadius:"5px", maxHeight:"365px", overflowY:"auto"}}>
                {(notesData.length == 0 ) && 
                <Form.Label className="mb-1 mt-2"><b>{t("modal_creationactivities_text19")}</b></Form.Label>
                }
                {(notesData.length >= 1) && 
                <Form.Label className="mb-1">{t("modal_creationactivities_notes_6")}</Form.Label>
                }
                <Col lg={12}  >
                  {(commentsToShow()) ? 
                  <>
                  {  commentsToShow()?.map((item,idx)=>{
                    return <Col lg={12} key={idx} className="mb-0 pb-0 d-flex border-bottom rounded border-2 border-light" style={{backgroundColor:"#e9ecef"}}>
                            <div style={{width:"100%"}} className="mr-2 " >
                            <small className="mr-2">{item.name}</small>
                            <small>{t("modal_creationactivities_notes_1")} {item.createDate}</small>
                            <Form.Control
                            key={idx}
                            as="textarea"
                            className="mb-1 pb-0"
                            style={{border:"none"}}
                            name="text"
                            value={item.text}
                            disabled = {(idx == enableEdit )? false:true}
                            onChange={(e)=> {
                              handleOnChangeForNotes(e,item.idComment)
                            }}
                            />
                            </div>
                            <div className="d-flex justify-content-around align-items-center">
                            {(idx != enableEdit)? <>
                              <i className="text-info fa fa-edit mr-2" 
                                  style={{cursor:"pointer"}}
                                  onClick={(e)=>{
                                    if(props.rol != "Ejecutivo"){
                                      handleEditNote(idx)
                                    }else {
                                      return
                                    }
                                  }}                               
                                  >
                                  
                              </i>
                              <i className="text-danger fas fa-trash"
                                  style={{cursor:"pointer"}}
                                  onClick={(e)=>{
                                    if(props.rol != "Ejecutivo"){
                                      deleteNote(item.idComment)
                                    }else {
                                      return
                                    }
                                  }}
                              ></i>
                            </> :""
                            }
                            {(idx == enableEdit)? 
                            <>
                            <div className="d-flex flex-column">
                            <Button
                              type="button"
                              variant="info"
                              size="sm"
                              className="p-1 mb-1"
                              onClick={(e)=> {
                                editNote(item.idComment)
                              }}
                            >
                            {t("modal_creationactivities_button_save")}
                            </Button>
                            <Button
                              type="button"
                              variant="dark"
                              size="sm"
                              className="p-1 m-0"
                              onClick={(e)=> {
                                setEnableEdit()
                                setEditNotes(false)
                                getAllNotes(props.data.current.id)
                              }}
                            
                            >
                            {t("modal_creationactivities_button_cancel")}
                            </Button>
                            </div>
                            </> :
                            
                            "" }
                            </div>
                            </Col>
                  })}
                  
                  </>
                  :""
                  }
                </Col>
                </Row>
                <Row>
                  <Form
                  style={{backgroundColor:"#e9ecef", borderBottomLeftRadius:"5px", borderBottomRightRadius:"5px"}}
                  className="w-100 mb-2 px-1"
                  > 
                  {(notesData?.length >= 1 ) && 
                  
                    <Form.Label><b>{t("modal_creationactivities_notes_2")}</b></Form.Label>
                  }
                    <Col lg={12} md={12}>
                 
                      <Form.Control
                      ref={noteref}
                      as="textarea"
                      className="mb-2"
                      
                      name="newComment"
                      placeholder={t("modal_creationactivities_text20")}
                      onChange={(e) => {
                        inputChange(e,setNewNote);
                      }}
                      />
                      <Button
                      type="button"
                      variant="success"
                      size="sm"
                      className="p-1 mb-2"
                      onClick={(e)=> {
                        createNewNote(e)}
                      }
                      disabled={(props.rol == "Ejecutivo")? true : false}
                    >
                     <icon class="fa fa-sticky-note mr-2"/>{t("modal_creationactivities_notes_3")}
                    </Button>
                    </Col>
                  </Form>
                  </Row>
                <small style={{ whiteSpace: "pre-wrap" }}>
                  {toPlainText(_getValue("Seguimiento"))}
                </small>
                <br/>
                 <Button
                    className="mt-2 mb-2"
                    type="button"
                    variant="outline-info"
                    onClick={() => {
                      setShowTrack(value => value = !value)
                    }}
                  >
                  <i className={(showTrack)?"fa fa-times mr-2":""}></i>{t("modal_creationactivities_button_traceability")}
                </Button>
                  <div className={(showTrack)? "d-block":"d-none"}>
                  <Col md={12}>
                    <small className="table table-striped w-100" style={{ whiteSpace: "pre-wrap" }}>
                      {toPlainText(getTrack[0]?.Trazabilidad)}
                    </small>
                    </Col>
                  </div>

              </Col>
            </Row>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              type="button"
              variant="dark"
              onClick={(e) => {
                setTaskData({})
                props.setShow(false);
              }}
            >
              <i className="fa fa-times mr-2"></i>{t("modal_creationactivities_button_cancel")}
            </Button>
            <Button
              type="submit"
              variant="success"
              onClick={(e)=>handleValidations(e,taskData)}
              disabled={(props.rol == "Ejecutivo")? true : false}
            >
              <i className="fa fa-save mr-2"></i>{t("modal_creationactivities_button_save")}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
      <ModalSelectResources
        show={showResources}
        setShow={setShowResources}
        resources={props.resources} // all resources
        selectedResources={selectedResources} // selected resources
        setResources={setSelectedResources}
      />
       <ModalSelectTags
        show={showTags}
        setShow={setShowTags}
        tags = {props.tags}
        selectedTags={selectedTags} 
        setSelectedTags={setSelectedTags}
      />
        <Suspense fallback={"loading..."}>
          <ModalAvancedOptions
          setShow={setShowAvancedOptions}
          show={showAvancedOptions}
          handleClose = {handleShowAcvancedOptions}
          data={taskData}
          handleValidations = {handleValidations}
          getAllprojectData ={props.getAllprojectData}
          />
        </Suspense> 
    </>
  );
};

export default React.memo(ModalEditTask);
